import { SVGProps } from 'react';

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      id="mask0_410_3278"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={10}
      height={10}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84986 9.73287L4.99349 5.87027L1.10751 9.73287C0.867322 9.97336 0.476943 9.97336 0.236757 9.73287C-0.00404925 9.49299 -0.00404925 9.10373 0.236757 8.86323L4.12211 5.00001L0.236757 1.13851C-0.00404925 0.898011 -0.00404925 0.508752 0.236757 0.268874C0.476943 0.0283765 0.867322 0.0283765 1.10751 0.268874L4.99349 4.13038L8.84986 0.268874C9.09004 0.0283765 9.4798 0.0283765 9.72061 0.268874C9.96079 0.509372 9.96079 0.898631 9.72061 1.13851L5.86424 5.00063L9.72061 8.86323C9.96141 9.10311 9.96141 9.49299 9.72061 9.73287C9.48042 9.97274 9.09004 9.97274 8.84986 9.73287Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_410_3278)">
      <rect width="10" height="10" fill="currentColor" />
    </g>
  </svg>
);
